import type { RouteObject } from 'react-router';

import { registerEditorialBlocks } from '../_shared/blocks';
import { EditorialPage } from './Editorial';

/**
 * The post list, and the review queue as its «بانتظار المراجعة» chip.
 *
 * **Block registration happens here**, at the feature's first route module, so
 * the editor and the renderer are both populated before any editorial surface
 * mounts — and so a console session that never opens this section pays nothing
 * for a registry it does not use. It is idempotent; the three sibling routes
 * call it too, and the second call returns.
 *
 * The guard chain runs on the console layout route above, so this route adds no
 * loader. Every read and every transition is authorized by `backend-content` on
 * the request itself — including the two-person rule, which is refused server
 * side whatever this bundle renders.
 */
registerEditorialBlocks();

export const editorialRoute: RouteObject = {
  path: 'editorial',
  element: <EditorialPage />,
};
